import React, { Component } from 'react';
import styles from '../css/VacantSubstitutions.module.css';
import Axios from '../../../components/Axios';
import VacantSubstitutionResult from './VacantSubstitutionResult';

class VacantSubstitutions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            data: []
        };
    }

    componentDidMount() {
        this.load();
    }

    load() {
        Axios('/api/v1/admin/get-vacant-substitutions', {}, (data) => {
            this.setState({ loaded: true, data: data });
        });
    }

    render() {
        let rows = [];
        if (this.state.data) {
            for (let i = 0; i < this.state.data.length; i++) {
                rows.push(
                    <VacantSubstitutionResult
                        key={i}
                        number={i}
                        data={this.state.data[i]}
                        onEdit={() => this.props.openEditDialog(this.state.data[i], () => this.load())}
                        onDelete={() => this.props.openDeleteDialog(this.state.data[i], () => this.load())}
                    />
                );
            }
        }

        return (
            <div className={styles.VacantSubstitutions}>
                <div className={styles.headerRow}>
                    <div className={styles.colVacant}>VACANT TERRITORY</div>
                    <div className={styles.colSubRep}>SUBSTITUTE REP</div>
                    <div className={styles.colSubTerr}>SUB TERRITORY</div>
                    <div className={styles.colMgr}>DIST MGR</div>
                    <div className={styles.colStatus}>STATUS</div>
                    <div className={styles.colActions}>ACTIONS</div>
                </div>
                <div className={styles.results}>
                    {this.state.loaded ? (rows.length > 0 ? rows : <div className={styles.empty}>No substitutions found.</div>) : 'Loading...'}
                </div>
            </div>
        );
    }
}

export default VacantSubstitutions;
